// extracted by mini-css-extract-plugin
export default {"note":"WhatWeDo_note__MZzdd"};